import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { SCRIPTS, ScriptsService } from 'src/app/core/service/scripts.service';
import { EnvironmentService } from 'src/environments/environment.service';
import { ShowUIService } from '../../service/show-ui.service';
import { SpinnerService } from '../../service/spinner.service';
import { AuthService } from 'src/app/domain/auth/service/auth.service';
import { HorizontalNavBarComponent } from 'src/app/core/component/hornavbar/horizontal-nav-bar.component';
import { OrgUserManagementUrls } from "../../../domain/org-user-management/module/org-user-mngmnt-routing";
import { EntranceUrl } from "../../../domain/entrance/service/entrance.service";
import { KPI_URLS } from "../../../domain/kpi/module/kpi-module-routing.module";

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit {
  private _destroyStream: Subject<void> = new Subject<void>();
  private isMetricsActivated = this.env.isProduction();

  hide = {
    sideNav: false,
    horNav: false,
  };

  isLoggedIn = false;
  isSpinnerActive: boolean;
  mainStyle: MainStyle = {
    'margin-left.rem': '0',
    'padding-top.rem': '0',
    'overflow-y': 'inherit',
    sideNavOpacity: 'opacity0',
  };

  @ViewChild('horNavBar') horNavBar: HorizontalNavBarComponent;

  constructor(
    private title: Title,
    public router: Router,
    private scriptsService: ScriptsService,
    private renderer: Renderer2,
    private env: EnvironmentService,
    private showUIService: ShowUIService,
    public spinner: SpinnerService,
    private authService: AuthService,
  ) {
    if (this.env.isStaging()) {
      this.title.setTitle(this.getAppTitleForTestEnvironments());
    }
  }

  ngOnInit(): void {
    const { isMetricsActivated } = this;
    if (isMetricsActivated) {
      // this.scriptsService.insertJsScriptText(this.renderer, SCRIPTS.ym); // please do not remove this comment
      this.scriptsService.loadJsScript(this.renderer, SCRIPTS.google.url);

      this.scriptsService.insertJsScriptText(this.renderer, SCRIPTS.stylesCssLinkPatching);
      this.scriptsService.insertJsScriptText(this.renderer, SCRIPTS.google.init);
    }

    this.router.events
      .pipe(takeUntil(this._destroyStream))
      .subscribe((val) => {
        if (val instanceof NavigationEnd) {
          this.updateHideNavBars();
          this.mainStyle['margin-left.rem'] = this.hide.sideNav ? '0' : '4.4';
          this.mainStyle['padding-top.rem'] = this.hide.horNav ? '0' : '4.4';
        }
      });

    this.authService.isLoggedInState$.subscribe((v) => {
      this.isLoggedIn = v;
    });

    this.showUIService.showUI.pipe(takeUntil(this._destroyStream))
      .subscribe(
        (v) => {
          this.mainStyle.sideNavOpacity = Boolean(v) ? 'opacity1' : 'opacity0';
        });

    this.spinner.isActive.pipe(takeUntil(this._destroyStream)).subscribe((isActive) => {
      if (isActive === undefined) {
        return;
      }
      this.isSpinnerActive = isActive;
      this.mainStyle['overflow-y'] = isActive ? 'clip' : 'inherit';
    });
  }

  private updateHideNavBars(): void {
    const path = window.location.pathname;
    this.hide.sideNav = URLS_WITHOUT_SIDE_NAV.some((pageName) => path.includes(pageName));
    this.hide.horNav = URLS_WITHOUT_HOR_NAV.some((pageName) => path.includes(pageName));
  };

  private getAppTitleForTestEnvironments(): string {
    const hostname = window.location.hostname;
    if (hostname.includes('staging')) {
      return AppTitleForTestEnvironments.STAGING;
    }
    if (hostname.includes('pre-demo')) {
      return AppTitleForTestEnvironments.PRE_DEMO;
    }
    if (hostname.includes('demo')) {
      return AppTitleForTestEnvironments.DEMO;
    }
  }
}

interface MainStyle {
  'margin-left.rem': string;
  'padding-top.rem': string;
  'overflow-y': string;
  sideNavOpacity: 'opacity0' | 'opacity1';
}

const URLS_WITHOUT_HOR_NAV: string[] = [
  'login',
  'maintenance',
  'published-investor-report',
  'documents/data-room/external',
  `${KPI_URLS.base}/${KPI_URLS._external}`,
];

const URLS_WITHOUT_SIDE_NAV: string[] = [
  'login',
  'maintenance',
  'cabinet',
  OrgUserManagementUrls.base,
  EntranceUrl,
  'published-investor-report',
  'documents/data-room/external',
  `${KPI_URLS.base}/${KPI_URLS._external}`,
];

enum AppTitleForTestEnvironments {
  STAGING = 'Orca Staging',
  DEMO = 'Orca Demo',
  PRE_DEMO = 'Orca Pre-demo',
}


